import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { getConfig } from '../store/slices/getConfig';
import { syncStatus } from '../store/slices/syncStatus';
import { saveDataFilter } from '../store/slices/dataFilter';
import { getFilterData } from '../store/slices/getFilterData';
import { getAttributes } from '../store/slices/getPImAttributes';
import { getAssociationType } from '../store/slices/getAssociationType';
import { retrieveSalesChannels } from '../store/slices/retreiveSalesChannel';
import { getShopifyAppConfig } from '../store/slices/getShopifyAppConfig';
import {getCategories} from "../store/slices/getCategories";
import Instructions from '../components/Instructions/Instructions';
import DataSync from '../components/DataSync/DataSync';
import LinkReset from '../components/LinkReset/LinkReset';
import SyncStatus from '../components/SyncStatus/SyncStatus';
import Configurations from '../components/Configurations/Configurations';
import { parseShopifyHost } from '../utils/parseShopifyHost';
import { getCookie } from '../utils/cookie';
import Subscription from '../components/Subscription';
import { Topbar } from '../components/Topbar';
import { Agreement } from '../components/Agreement';
import Footer from '../components/Footer';
import Layout from '../components/Layout';
import StoreLimitTracker from '../components/StoreLimitTracker';
import {storeLimit} from '../store/slices/storeLimit';
import {getPlanDetails} from '../store/slices/getPlanDetails';
import { useAppBridge } from "@shopify/app-bridge-react";
import { getSessionToken } from "@shopify/app-bridge-utils";
import {setAppReady} from "../store/slices/appSlice";
import {getAssetsFamilies} from "../store/slices/assetsFamiliesSlice";
import useInstallBackend from "../hooks/useInstallBackend";
import ShopifyInstall from '../components/ShopifyInstallApp';
import {getShopifyMarkets} from '../store/slices/getShopifyMarketsSlice';



export async function getServerSideProps({ query }) {
  const { shop, host, embedded } = query;

  // if (embedded === "1" && shop) {

  //   //  Coming back from OAuth with isNewInstall=1
  //   // Hook will run client side to create/activate backend record
  //   // Don't check backend yet, let hook run first
  //   if (query.isNewInstall === "1") {
  //     return { props: {} };
  //   }

  //   //  Normal load — check backend status
  //   try {
  //      const response = await fetch(`${process.env.RESTAPI_URL}/shopifyapp/installation-status/${shop}`, {
  //       method: "GET",
  //     });
  //     console.log(JSON.stringify(response));

  //     // Fresh install = not found in backend = needs OAuth
  //     if (!response.ok) {
  //       console.log("installation Status API is failing in prod server");
  //       return { props: {} };
  //     }
  //     const data = await response.json();
  //     console.log(JSON.stringify(data));
  //     const status = data?.data?.isInstalled;
  //     console.log(status)
  //     //  ACTIVE = fully installed, let through
  //     if (status) {
  //       console.log("already active skipping");
  //       return { props: {} };
  //     }

  //     //  INACTIVE = had OAuth before but uninstalled
  //     // No need for OAuth again, token exists in backend
  //     // Just trigger hook to reactivate
  //     if (!status) {
  //       console.log("inactive doing");
  //       return {
  //         redirect: {
  //           destination: `/api/shopify/auth?shop=${shop}&host=${host}&embedded=1`,
  //           permanent: false,
  //         },
  //       };
  //     }

  //   } catch (e) {
  //     return { props: {} };
  //   }

  //   return { props: {} };
  // }

  // Draft app / first install
  if (shop) {

  if (query.isNewInstall === "1") {
    return { props: {} };
  }

  //  Normal load — check backend status
  try {
    const response = await fetch(`${process.env.RESTAPI_URL}/shopifyapp/installation-status/${shop}`, {
      method: "GET",
    });
    // Fresh install = not found in backend = needs OAuth
    if (!response.ok) {
      return { props: {} };
    }
    const data = await response.json();
    const status = data?.data?.isInstalled;
    //  ACTIVE = fully installed, let through
    if (status) {
      return { props: {} };
    }

    //  INACTIVE = had OAuth before but uninstalled
    // No need for OAuth again, token exists in backend
    // Just trigger hook to reactivate
    if (!status) {
      return {
        redirect: {
          destination: `/api/shopify/auth?shop=${shop}&host=${host || ""}&embedded=${embedded}`,
          permanent: false,
        },
      };
    }

  } catch (e) {
    return { props: {} };
  }
}
return { props: {} };
}


const Index = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  // const app = useAppBridge();

  // const testAppBridgeToken = async () => {
  //   try {
  //     console.log("Requesting token from App Bridge...");
      
  //     // Fetch the session token
  //     const token = await getSessionToken(app);
      
  //     // Print it to the browser's developer console
  //     console.log("SUCCESS! Here is your session App Bridge Token:");
  //     console.log(token);
      
  //   } catch (error) {
  //     console.error(" Failed to get token:", error);
  //   }
  // };
  // const { installComplete } = useInstallBackend();
  // Local State
  const [activeTab, setActiveTab] = useState("configuration");
  const [currentTab, setCurrentTab] = useState("configuration");
  const [isClient, setIsClient] = useState(false);
  const [isSubscriptionOpen, setIsSubscriptionOpen] = useState(false);
  const [isAgreementOpen, setIsAgreementOpen] = useState(false);
  const [isReloading, setIsReloading] = useState(false);
  const [isChangePlan, setIsChangePlan] = useState(false);

  // Redux State
  const savedData = useSelector(state => state.config.data);
  const storeDomain = useSelector(state => state.config?.clientStoreHash);
  const prodConfigId = useSelector(state => state.productMapping?.configId);
  const storeLimitData = useSelector(state => state.storeLimit?.data);
  const shopifyAppData = useSelector(state => state.shopifyAppConfig?.data);
  const isInitConfig = useSelector(state => state.shopifyAppConfig?.isinitConfigExist);
  const AggreementFlag = useSelector(state => state.storeLimit?.isAgreementAccepted);
  const isTrail = useSelector((state)=> state.storeLimit?.isTrail);
  const subscriptionShow = useSelector((state) => state.storeLimit?.isSubscriptionShow);
  const trailDetails = useSelector((state)=>state.storeLimit?.trailDetails);
  const availableCredits = parseInt(trailDetails?.allowedCredit, 10) || 0;
  const consumedCredits = parseInt(trailDetails?.usedCredit, 10) || 0;
  const availableTrailDays = parseInt(trailDetails?.allowedTrialDays, 10)|| 0;
  const consumedTrailDays = parseInt(trailDetails?.usedTrialDays, 10) || 0;
  
  const getConfigStatus = useSelector(state => state.config?.status);
  const getShopifyAppStatus = useSelector(state => state.shopifyAppConfig?.status); 
  const getStoreLimitStatus = useSelector(state => state.storeLimit?.status);
  const isAppReady = useSelector((state) => state.app.isAppReady);
  const getSubscriptionStatus = useSelector(state => state.storeLimit?.planStatus);

  // Extract primitives to prevent object-reference loops
  const configId = savedData?.struConfigId;
  const locale = savedData?.basicFilter?.dataFilter?.locale;
  const isBasicFilterEmpty = savedData?.basicFilter && Object.keys(savedData.basicFilter).length === 0;

  // Ref to track if we already fetched this data to prevent double calls
  const lastFetchedRef = useRef("");
  const { isShopifyApp, shopName } = parseShopifyHost();

  // ── Add this state at top of component ──
  const [installComplete, setInstallComplete] = useState(() => {
    if (!isShopifyApp) return true;
    if (typeof window === "undefined") return true;
    
    // Look directly at the window URL query
    const params = new URLSearchParams(window.location.search);
    const isNewInstall = params.get("isNewInstall") === "1";
    
    return !isNewInstall;
  });

  useEffect(() => {
    const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
    const hasShopParam = searchParams ? searchParams.has('shop') : false;

    if ((!window.location.search.includes('?storeHash=') || getCookie('isAuthenticated') !== 'true') && !isShopifyApp && !hasShopParam) {
      router.push('/login');
    }
    setIsClient(true);
  }, [router, isShopifyApp]);

  const reloadIframe = () => {
    setIsReloading(true);
    setTimeout(() => {
      setIsReloading(false)
    }, 500);
  };

  const getClientConfig = () => {
    if (typeof window === 'undefined') return '';
    
    const { shopName } = parseShopifyHost();
    if (shopName) return shopName;

    const params = new URLSearchParams(window.location.search);
    if (params.has('shop')) return params.get('shop');

    const urlParam = window.location.search;
    return urlParam.replace("?storeHash=", "");
  };

  const syncStatusInfo = () => {
    const idToSync = savedData?.struConfigId || prodConfigId;
    if (idToSync) {
      dispatch(syncStatus(idToSync));
    }
  };

  // Wrapped in useCallback so it doesn't recreate on every render
  const fetchInitialConfig = useCallback(async () => {
    if (typeof window === 'undefined') return;
    const clientConfig = getClientConfig();
    if (clientConfig !== '') {  // Mark APIs as triggered — removes blank field flash
      await dispatch(storeLimit(clientConfig));
      try {
        await dispatch(getConfig(clientConfig)).unwrap();
        await Promise.all([
          dispatch(retrieveSalesChannels(clientConfig)),
          dispatch(getShopifyAppConfig(clientConfig)),
          dispatch(getPlanDetails()),
        ]);
      } catch (error) {
        await Promise.all([
          dispatch(getShopifyAppConfig(clientConfig)),
          dispatch(getPlanDetails()),
        ]);
      }finally{
        dispatch(setAppReady());
      }
    }
    setActiveTab('configuration');
  }, [dispatch]);



  // Run only once on mount
  useEffect(() => {
    if(!installComplete) return;
    fetchInitialConfig();
  }, [installComplete, fetchInitialConfig]);

  // Optimized Data Fetching 
  useEffect(() => {
    if (!configId) return;

    // Create a unique key for this request
    const fetchKey = `${configId}-${locale || 'default'}`;

    // If we already fetched this specific combination, STOP.
    if (lastFetchedRef.current === fetchKey) return;

    // Mark as fetched
    lastFetchedRef.current = fetchKey;
    const clientConfig = getClientConfig();

    if (locale) {
      dispatch(getFilterData({ configId, locale }));
      dispatch(getAttributes({ configId, locale }));
      dispatch(getAssociationType({ configId, locale }));
      dispatch(retrieveSalesChannels(storeDomain));
      dispatch(getCategories({configId,locale}));
      dispatch(getAssetsFamilies({configid:configId,locale}));
      dispatch(getShopifyMarkets({configid:configId}));
    } else if (isBasicFilterEmpty) {
      dispatch(getFilterData({ configId, locale: "en_US" }));
    }
  }, [configId, locale, isBasicFilterEmpty, storeDomain, dispatch]);

  useEffect(() => {
    if (savedData?.basicFilter) {
      dispatch(saveDataFilter(savedData));
    }
  }, [savedData?.basicFilter, dispatch]);

  useEffect(() => {
    if(isShopifyApp && typeof subscriptionShow === "boolean" && subscriptionShow ){
      setIsSubscriptionOpen(true);
      setIsChangePlan(true);
    }
    if(isShopifyApp && typeof subscriptionShow === "boolean" && !subscriptionShow){
      setIsSubscriptionOpen(false);
      setIsChangePlan(false);
    }
  }, [subscriptionShow, storeLimitData, isShopifyApp]);

  const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  const isShopifyContext = isShopifyApp || (searchParams && searchParams.has('shop'));

  
  if (!isClient) return null;
   if (isShopifyApp && !installComplete) {
    return <ShopifyInstall onComplete={() => setInstallComplete(true)} />;
  }
  if(isShopifyApp){
    if (!isAppReady) {
    return (
      <Layout />
    );
    }
  }
  
  return (
    <>
      <StoreLimitTracker />
      
      {/* {isShopifyApp && (
        <ShopifyInstall onComplete={() => setInstallComplete(true)} />
      )} */}
      {isReloading ? (
        <Layout />
      ) : (
        <>
          <Agreement />
          <Topbar onSubscriptionOpen={() => setIsSubscriptionOpen(true)} />

            {/* <button 
                onClick={testAppBridgeToken} 
                className="btn btn-success"
              >
                Generate Token & Log to Console
            </button> */}

          <nav style={{ minHeight: "75vh" }}>
            <Tab.Container
              id="main-tabs"
              activeKey={activeTab}
              onSelect={(key) => {
                if (!isSubscriptionOpen && key) {
                  setActiveTab(key);
                  setCurrentTab(key);
                }
              }}
            >
              <div className='header'>
                <div className='container'>
                  <Nav variant="pills" style={{ display: "flex", height: "50px" }}>
                    <Nav.Item>
                      <Nav.Link eventKey="instructions" className="my-0 tab-btn">
                        Instructions
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="configuration"
                        className="my-0 tab-btn"
                        onClick={() => { fetchInitialConfig(); reloadIframe(); }}
                      >
                        Configuration
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="data-sync" className="my-0 tab-btn">
                        Data Sync
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="sync-status"
                        className="my-0 tab-btn"
                        onClick={syncStatusInfo}
                      >
                        Sync Status
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="pim-reset" className="my-0 tab-btn">
                        PIM2Shopify Link Refresh
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>

              <div className='container'>
                <Row>
                  <Col>
                    {isSubscriptionOpen ? (
                      <div className="subscription-content p-4 mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <h2 className="mb-0 fw-bold">Change Plan</h2>
                          <button className="stru-btn btn btn-primary" onClick={() => setIsSubscriptionOpen(false)} disabled={isChangePlan}>
                            Back to App
                          </button>
                        </div>
                        <Subscription />
                      </div>
                    ) : (
                      <Tab.Content mountonenter="true">
                        <Tab.Pane eventKey="instructions"><Instructions /></Tab.Pane>

                        <Tab.Pane eventKey="configuration">
                          <Configurations selectedTab={currentTab} changeTab={setActiveTab}/>
                        </Tab.Pane>

                        <Tab.Pane eventKey="data-sync">
                          <DataSync changeTab={setActiveTab} />
                        </Tab.Pane>

                        <Tab.Pane eventKey="sync-status">
                          <SyncStatus currentActiveTab={currentTab} />
                        </Tab.Pane>

                        <Tab.Pane eventKey="pim-reset">
                          {currentTab === "pim-reset" && (<LinkReset key={currentTab} currentTab={currentTab} />)}
                        </Tab.Pane>
                      </Tab.Content>
                    )}
                  </Col>
                </Row>
              </div>
            </Tab.Container>
          </nav>
          <Footer />
        </>
      )}
    </>
  );
};

export default Index;